export default __webpack_public_path__ + "static/media/sales-by-brick.3c5d2071.svg";